import React, { useEffect, useRef } from 'react';

import { useMapContext } from './context';

export const DirectionsRenderer: React.FC<{
  directions?: google.maps.DirectionsResult;
  options?: google.maps.DirectionsRendererOptions;
}> = ({ directions, options }) => {
  const { maps, map } = useMapContext();
  const directionsRendererRef = useRef<google.maps.DirectionsRenderer | null>(
    null,
  );
  const appliedDirectionsRef = useRef<google.maps.DirectionsResult | null>(
    null,
  );
  const appliedOptionsRef = useRef<
    google.maps.DirectionsRendererOptions | undefined
  >(undefined);

  if (!maps || !map) throw new Error('No map found');

  useEffect(() => {
    if (!directions) {
      return;
    }

    if (!directionsRendererRef.current) {
      directionsRendererRef.current = new maps.DirectionsRenderer(options);
    }

    const directionsRenderer = directionsRendererRef.current;
    if (directionsRenderer.getMap() !== map) {
      directionsRenderer.setMap(map);
    }

    if (appliedDirectionsRef.current !== directions) {
      directionsRenderer.setDirections(directions);
      appliedDirectionsRef.current = directions;
    }

    if (appliedOptionsRef.current !== options) {
      if (options !== undefined) {
        directionsRenderer.setOptions(options);
      }
      appliedOptionsRef.current = options;
    }
  }, [map, directions, options, maps]);

  useEffect(() => {
    return () => {
      directionsRendererRef.current?.setMap(null);
      directionsRendererRef.current = null;
      appliedDirectionsRef.current = null;
      appliedOptionsRef.current = undefined;
    };
  }, []);

  return null;
};
